
  var _styles = {
  "traffic-filter-empty-text": {
    "fontFamily": "PingFangSC",
    "fontSize": "0.42667rem",
    "color": "rgb(51,51,51)",
    "textAlign": "center",
    "lineHeight": "0.46667rem",
    "marginTop": "0.2rem"
  },
  "traffic-filter-empty-image": {
    "width": "4rem",
    "height": "4rem"
  },
  "traffic-filter-empty-container": {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "traffic-filter-empty-desc": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.34667rem",
    "color": "rgb(166,166,166)",
    "textAlign": "center",
    "lineHeight": "0.37333rem",
    "marginTop": "0.37333rem"
  }
};



  module.exports = _styles;
  